import axios from 'axios';
import React from 'react'
import { useParams } from "react-router-dom";
import { BASE_URL } from '../../../../Screens/Settings/DASHBOARD_SETTINGS';
import { toast } from "react-toastify";
import { Button, buttonVariants } from '../../../Global/UI/Button';
import { ThreeDots } from 'react-loader-spinner'
import { useHistory } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose, DialogDescription } from '../../../../Components/Global/UI/Dialog';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from "../../../../Components/Global/UI/Command"
import { Popover, PopoverContent, PopoverTrigger } from "../../../../Components/Global/UI/Popover"
import { Check, ChevronsUpDown } from "lucide-react"
import { Input } from '../../../Global/UI/Input';
import { Label } from '../../../Global/UI/Label';
import ReferrerDetails from '../ReffererDetails';
import ViewStaffDetails from './ViewStaffDetails';
import ViewRiskAssessment from './ViewRiskAssessmentData';
import ViewEventDetails from './ViewEventDetails';
import ViewReferrerDetails from './ViewReferrerDetails';

const ViewEventsDetails = () => {

    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const { JobID } = useParams();
    const [jobDetails, setJobDetails] = React.useState({
        itemId: '',
        referenceCode: '',
        referrerDetails: {},
        eventDetails: {},
        riskAssessment: {},
        staffDetails: {},
    });
    const [loading, setLoading] = React.useState(true);
    const history = useHistory()
    const [selectedDriverUsername, setSelectedDriverUsername] = React.useState("");
    const [drivers, setDrivers] = React.useState(null);

    const handleAssignJob = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/events/assignJob/${selectedDriverUsername.toUpperCase()}/${jobDetails.itemId}`);
            if (response.data.success) {
                toast.success(`Sucessfully Assigned Job: ${jobDetails.itemId}.`);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    toast.error(error.response.data.message);
                    console.error('Item not found:', error.response.data.message);
                }
            } else if (error.request) {
                toast.error("An unknown error has occured");
                console.error('No response received:', error.request);
            } else {
                toast.error("An unknown error has occured");
                console.error('Error setting up the request:', error.message);
            }
        }
    };

    const fetchDrivers = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/drivers/getDrivers`);
            if (response.data.success) {
                setDrivers(response.data.drivers);
            }
        } catch (error) {
            console.error('Error fetching drivers:', error.message);
            toast.error('Failed to fetch drivers');
        }
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    const handleStaffDetailsChange = (data) => {
        console.log('Events Staff Details:', data)
        setJobDetails(prevJobDetails => ({
            ...prevJobDetails,
            staffDetails: data
        }));
    };

    const handleRiskAssessmentChange = (data) => {
        console.log('Events Risk Assessment Details:', data)
        setJobDetails(prevJobDetails => ({
            ...prevJobDetails,
            riskAssessment: data
        }));
    };

    const handleEventDetailsChange = (data) => {
        console.log('Events Details:', data)
        setJobDetails(prevJobDetails => ({
            ...prevJobDetails,
            eventDetails: data
        }));
    };

    const handleReferrerDetailsChange = (data) => {
        console.log('Events Referrer Details:', data)
        setJobDetails(prevJobDetails => ({
            ...prevJobDetails,
            referrerDetails: data
        }));
    };

    const handleJobDelete = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/events/${jobDetails.itemId}/remove-request`);
            if (response.data.success) {
                toast.success(response.data.msg);
                history.push('/')
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error(error.response.data.msg);
                    console.error('Validation errors:', error.response.data.msg);
                }
            } else if (error.request) {
                toast.error("An unknown error has occured");
                console.error('No response received:', error.request);
            } else {
                toast.error("An unknown error has occured");
                console.error('Error setting up the request:', error.msg);
            }
        }
    }

    const cancelJob = async (status) => {
        try {
            const response = await axios.get(`${BASE_URL}/api/events/${jobDetails.itemId}/cancel-job`);
            if (response.data.success) {
                toast.success(response.data.msg);
                history.push('/')
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error(error.response.data.message);
                    console.error('Validation errors:', error.response.data.errors);
                }
            } else if (error.request) {
                toast.error("An unknown error has occured");
                console.error('No response received:', error.request);
            } else {
                toast.error("An unknown error has occured");
                console.error('Error setting up the request:', error.message);
            }
        }
    }

    const handleUpdateJob = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/api/events/${jobDetails.itemId}/updateRequest`, jobDetails);
            if (response.data.success) {
                toast.success(response.data.msg);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    toast.error(error.response.data.message);
                    console.error('Item not found:', error.response.data.message);
                }
            } else if (error.request) {
                toast.error("An unknown error has occured");
                console.error('No response received:', error.request);
            } else {
                toast.error("An unknown error has occured");
                console.error('Error setting up the request:', error.message);
            }
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${BASE_URL}/api/events/job/${JobID}`
            );
            console.log(response.data)
            if (response.data.success) {
                setLoading(false);
                console.log('Response Data:', response.data)
                setJobDetails({
                    itemId: response.data.job._id || '',
                    referenceCode: response.data.job.referenceCode || '',
                    referrerDetails: response.data.job.referrerDetails || {},
                    eventDetails: response.data.job.eventDetails|| {},
                    riskAssessment: response.data.job.riskAssessment|| {},
                    staffDetails: response.data.job.staffDetails || {},
                });
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setLoading(false);
                    toast.error(error.response.data.message);
                    console.error("Item not found:", error.response.data.message);
                }
            } else if (error.request) {
                setLoading(false);
                toast.error("An unknown error has occurred");
                console.error("No response received:", error.request);
            } else {
                setLoading(false);
                toast.error("An unknown error has occurred");
                console.error("Error setting up the request:", error.message);
            }
        }
    };
    React.useEffect(() => {
        fetchData();
        fetchDrivers();
    }, []);



    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <ThreeDots
                    height="80"
                    width="80"
                    color="#000000"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    visible={true}
                />
            </div>
        );
    }

    return (
        <div className="full-overview m-10">

            <Dialog open={isDialogOpen} onOpenChange={handleCloseDialog}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Assign an ambulance</DialogTitle>
                        <DialogClose />
                    </DialogHeader>
                    <DialogDescription>
                        Assign an ambulance to this job.
                    </DialogDescription>
                    {drivers && (
                        <Popover open={open} onOpenChange={setOpen} >
                            <PopoverTrigger asChild>
                                <Button
                                    variant="outline"
                                    role="combobox"
                                    aria-expanded={open}
                                    className="w-auto justify-between"
                                >
                                    {selectedDriverUsername ? selectedDriverUsername.toUpperCase() : "Select Driver..."}
                                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                                </Button>
                            </PopoverTrigger>
                            <PopoverContent className="w-full p-0">
                                <Command>
                                    <CommandInput placeholder="Search Driver..." />
                                    <CommandEmpty>No Driver found.</CommandEmpty>
                                    <CommandGroup>
                                        {drivers.map((framework) => (
                                            <CommandItem
                                                key={framework.username}
                                                value={framework.username}
                                                onSelect={(currentValue) => {
                                                    const newSelectedDriver = currentValue === selectedDriverUsername ? "" : currentValue;
                                                    setSelectedDriverUsername(newSelectedDriver);
                                                    setOpen(false);
                                                }}
                                            >
                                                <Check
                                                    className={`mr-2 h-4 w-4 ${selectedDriverUsername.toUpperCase() === framework.username ? "opacity-100" : "opacity-0"}`}
                                                />
                                                {framework.username}
                                            </CommandItem>
                                        ))}
                                    </CommandGroup>
                                </Command>
                            </PopoverContent>
                        </Popover>
                    )}
                    <Button
                        variant="default"
                        size="lg"
                        className={buttonVariants({ variant: "default", size: "lg" })}
                        onClick={() => handleAssignJob()}>
                        Assign Job
                    </Button>
                </DialogContent>
            </Dialog>


            <div className='flex flex-row justify-between'>
                {console.log(jobDetails)}
                <h2 className='font-semibold text-3xl'>Booking Overview - {jobDetails.referenceCode.toUpperCase()}</h2>
                <div>
                    {jobDetails.jobtimestamps && (
                        <Button
                            variant="default"
                            size="lg"
                            className={`${buttonVariants({ variant: "default", size: "lg" })} mr-2`}
                        // onClick={() => handleLogClick()}
                        >
                            View Log
                        </Button>
                    )}

                    <Button
                        variant="default"
                        size="lg"
                        className={buttonVariants({ variant: "default", size: "lg" })}
                        onClick={() => handleUpdateJob()}
                    >
                        Save Changes
                    </Button>
                    <Button
                        variant="default"
                        size="lg"
                        className={`${buttonVariants({ variant: "default", size: "lg" })} ml-2`}
                        onClick={() => setIsDialogOpen(true)}
                    >
                        Assign Job
                    </Button>
                    <Button
                        variant="default"
                        size="lg"
                        className={`${buttonVariants({ variant: "default", size: "lg" })} ml-2`}
                        onClick={() => cancelJob()}
                    >
                        Cancel Job
                    </Button>
                    <Button
                        variant="default"
                        size="lg"
                        className={`${buttonVariants({ variant: "default", size: "lg" })} ml-2`}
                        onClick={() => handleJobDelete()}
                    >
                        Delete Job
                    </Button>
                </div>
            </div>

            <div className='mt-6'>
                <p className='font-bold text-2xl mb-4'>Pricing Details</p>
                <div className='grid gap-4 grid-cols-1 md:grid-cols-3 mb-4'>
                    <div>
                        <Label htmlFor="price" className="block font-bold mb-2">Price:</Label>
                        <Input
                            // value={jobDetails.journeyDetails.price}
                            type="text"
                            id="price"
                            name="price"
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-inset focus:ring-teal-400"
                        />
                    </div>
                </div>
                <ViewReferrerDetails data={jobDetails.referrerDetails} onChange={handleReferrerDetailsChange} />
                <ViewEventDetails data={jobDetails.eventDetails} onChange={handleEventDetailsChange} />
                <ViewRiskAssessment data={jobDetails.riskAssessment} onChange={handleRiskAssessmentChange} />
                <ViewStaffDetails onChange={handleStaffDetailsChange} riskAssessmentScore={jobDetails.riskAssessment.riskScore ? jobDetails.riskAssessment.riskScore : 0} />
            </div>
        </div >
    )
};

export default ViewEventsDetails;
